import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSilverMedal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={29}
    height={28}
    fill='none'
    {...props}
  >
    <path
      fill='#B9C7D9'
      d='M22.31 22.756a1 1 0 0 1-1.44.831l-6.96-3.425a1 1 0 0 1-.058-1.764l7.474-4.314a1 1 0 0 1 1.497.932z'
    />
    <path
      fill='#B9C7D9'
      d='M6.088 22.756a1 1 0 0 0 1.44.831l6.96-3.425a1 1 0 0 0 .058-1.764l-7.473-4.314a1 1 0 0 0-1.498.932z'
    />
    <rect width={18} height={18} x={5.238} y={1} fill='#CFDDEB' rx={9} />
    <rect
      width={18}
      height={18}
      x={5.238}
      y={1}
      stroke='#B9C7D9'
      strokeWidth={2}
      rx={9}
    />
    <path
      fill='#7A88A0'
      d='M11.355 14v-1.02l2.771-2.835q.574-.58.891-.956.322-.38.451-.668.13-.293.13-.615V7.89q-.001-.387-.17-.692a1.2 1.2 0 0 0-.487-.474 1.53 1.53 0 0 0-.756-.176q-.446 0-.785.187a1.3 1.3 0 0 0-.527.51 1.5 1.5 0 0 0-.188.768l-.006.023-1.406-.006-.006-.017q0-.791.38-1.395a2.6 2.6 0 0 1 1.056-.943q.673-.34 1.558-.34.82 0 1.46.31.644.312 1.007.856t.363 1.26v.017q0 .475-.181.932-.182.45-.621.99-.434.54-1.202 1.283l-2.091 2.034.398-.668v.668l-.398-.264h4.224V14z'
    />
    <path
      fill='#DEE8F2'
      d='m17.81 3.438-1.018-.452-1.357-.422-.397.317-.042.452.25.479.323.274.845.35.75.404.647.422.583.451.657.591.544.798.342.46.499.14.324-.197v-.824l-.324-.573-.5-.884-.34-.384-.621-.67-.687-.484z'
    />
  </svg>
);
export default SvgSilverMedal;
